import type { MealItem } from "../api/diary";
import { unitLabel } from "../utils/units";

export type MealItemRowProps = {
  item: MealItem;
  onTap: () => void;
  fg: string;
  hint: string;
  accent: string;
  divider: string;
  isLast: boolean;
  kcalGoal?: number;
};

function fmt(n: number, digits = 2): string {
  if (!Number.isFinite(n)) return "0";
  return n.toFixed(digits).replace(".", ",");
}

function formatAmount(amount: number, unit: string): string {
  const rounded = Math.round(amount * 10) / 10;
  const str = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1).replace(".", ",");
  return `${str} ${unit}`;
}

export default function MealItemRow({ item, onTap, fg, hint, accent, divider, isLast, kcalGoal = 2000 }: MealItemRowProps) {
  const product = item.product;
  const amount = Number(item.amount);
  const factor = amount / 100;
  const kcalI = Number(product.kcal_100g) * factor;
  const pI = Number(product.protein_100g) * factor;
  const fI = Number(product.fat_100g) * factor;
  const cI = Number(product.carbs_100g) * factor;
  const rsk = Math.round((kcalI / kcalGoal) * 100);

  return (
    <button
      onClick={onTap}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 9,
        width: "100%",
        background: "transparent",
        border: "none",
        borderBottom: isLast ? "none" : `1px solid ${divider}`,
        padding: "9px 12px",
        cursor: "pointer",
        color: fg,
        fontFamily: "inherit",
        textAlign: "left",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 500, lineHeight: 1.25, color: fg, wordBreak: "break-word" }}>
          {product.name}
        </div>
        <div style={{ fontSize: 12, color: accent, marginTop: 2, fontWeight: 500 }}>
          {formatAmount(amount, unitLabel(product.unit))}
        </div>
        <div style={{ fontSize: 11, color: hint, marginTop: 3, display: "flex", gap: 8, fontVariantNumeric: "tabular-nums" }}>
          <span>{fmt(fI)}</span>
          <span>{fmt(cI)}</span>
          <span>{fmt(pI)}</span>
          <span>{rsk}%</span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 3, flexShrink: 0 }}>
        <div style={{ fontSize: 15, color: hint, fontWeight: 500, fontVariantNumeric: "tabular-nums" }}>
          {Math.round(kcalI)}
        </div>
        <span style={{ color: hint, fontSize: 16, lineHeight: 1 }}>›</span>
      </div>
    </button>
  );
}
